import React from "react";
import {Box, Button, Form, FormGroup, Rating, Stack, SubmitButton} from "@unibuddy/patron";
import * as yup from "yup";
import {FormikHelpers} from "formik";

type ConversationFeedbackRatingProps = {
    handleSubmit: (rating: number) => Promise<void>;
    handleDismiss: () => void;
};

type FormValues = {
    rating: number;
};

export const ConversationFeedbackRatingForm = ({
    handleSubmit,
    handleDismiss,
}: ConversationFeedbackRatingProps) => {
    return (
        <Form
            initialValues={{rating: undefined}}
            validationSchema={{
                rating: yup.string().required("Please select a rating"),
            }}
            onSubmit={async (
                values: {rating: number},
                {setSubmitting}: FormikHelpers<FormValues>,
            ) => {
                setSubmitting(true);
                try {
                    await handleSubmit(values.rating);
                } catch (error) {
                    console.error(error);
                    setSubmitting(false);
                }
            }}
        >
            {(props: {values: FormValues; isSubmitting: boolean}) => {
                const {values, isSubmitting} = props;
                return (
                    <Stack space="small-medium">
                        <FormGroup label="How helpful was this conversation?">
                            <Rating
                                name="rating"
                                min={1}
                                max={5}
                                minText="Not very helpful"
                                maxText="Extremely helpful"
                            />
                        </FormGroup>
                        <Box gap="small" display="flex">
                            <Button
                                color="default"
                                ghost
                                block
                                size="sm"
                                onClick={handleDismiss}
                                disabled={isSubmitting}
                            >
                                Continue chatting
                            </Button>
                            <SubmitButton
                                color="primary"
                                block
                                size="sm"
                                disabled={values.rating === undefined}
                            >
                                Submit
                            </SubmitButton>
                        </Box>
                    </Stack>
                );
            }}
        </Form>
    );
};
